import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'

@Component({
	selector: 'app-loading-page',
	templateUrl: './loading-page.component.html'
})
export class LoadingPageComponent implements OnChanges {

	@Input() public withPercent: boolean = false
		@Input() public totItens: number = 0
	@Input() public partialItens: number = 0
	@Input() public fetchingItens: number = 0

	@Output() public finishLoading = new EventEmitter()

	public percentProgress: number = 0

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.partialItens) {
			this.percentProgress = Number(
				(this.partialItens / this.totItens) * 100
			)
		}

		if (changes.partialItens && this.partialItens === this.totItens) {
			setTimeout(() => {
				this.finishLoading.emit()
			}, 50)
		}
	}
}
